import {
  useTrackContentView,
  useTrackFeature,
  useTrackFeatureInViewImpression,
} from '@aboutyou/tracking';
import React from 'react';

export const useTrackNotificationCenterButton = () => {
  const trackContentViewCallback = useTrackContentView();

  const trackingData = {
    label: `notification_center_entry`,
    name: 'notification_center_entry',
  };

  const {ref: featureImpressionRef} =
    useTrackFeatureInViewImpression<HTMLButtonElement>(trackingData);
  const trackFeature = useTrackFeature();

  const trackOnOpenNotificationCenter = React.useCallback(() => {
    trackFeature({
      eventType: 'click',
      ...trackingData,
    });
    trackContentViewCallback({
      pageTitle: 'notification_center',
    });
  }, [trackingData]);

  return {
    trackOnOpenNotificationCenter,
    featureImpressionRef,
  };
};
